import { useEffect, useRef } from 'react';

import {
  DISCLOSURE_DELIVERY_MAX_POLL_INTERVAL_MS,
  DISCLOSURE_DELIVERY_POLL_BACKOFF_FACTOR,
  DISCLOSURE_DELIVERY_POLL_INTERVAL_MS,
} from '../DisclosureDelivery.constants';

const useDisclosurePolling = ({ enabled, poll }) => {
  const pollRef = useRef(poll);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(DISCLOSURE_DELIVERY_POLL_INTERVAL_MS);
  const isCancelledRef = useRef(false);

  useEffect(() => {
    pollRef.current = poll;
  }, [poll]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    isCancelledRef.current = false;

    const clear = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };

    const schedule = () => {
      clear();

      if (isCancelledRef.current) {
        return;
      }

      timeoutRef.current = setTimeout(async () => {
        if (document.hidden) {
          schedule();

          return;
        }

        try {
          await pollRef.current();
          intervalRef.current = DISCLOSURE_DELIVERY_POLL_INTERVAL_MS;
        } catch {
          intervalRef.current = Math.min(
            intervalRef.current * DISCLOSURE_DELIVERY_POLL_BACKOFF_FACTOR,
            DISCLOSURE_DELIVERY_MAX_POLL_INTERVAL_MS,
          );
        }

        schedule();
      }, intervalRef.current);
    };

    schedule();

    return () => {
      isCancelledRef.current = true;
      clear();
    };
  }, [enabled]);
};

export default useDisclosurePolling;
